import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getDownloadPengurusKabkot,
  getDownloadDaftarAnggota,
} from "../../../config/Redux/Download/actions";
import { getKabKot } from "../../../config/Redux/Global/actions";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";

export default function BasicTable(param) {
  const dispatch = useDispatch();
  const [selectProvinsi, setProvince] = React.useState("11");
  const [selectKabkot, setCities] = React.useState("1101");
  // const [optionKabkot, setOptionKabkot] = React.useState([]);

  const dataDetail = useSelector((state) => state.download);
  const globalData = useSelector((state) => state.global);

  let dataAnggota = [];
  dataDetail?.downloadDaftarAnggota?.data?.map((list, idx, arr) => {
    dataAnggota[idx] = list;
    if (list.alamat === "data_ktp") {
      dataAnggota[idx]["alamat_tinggal"] = list.data_ktp;
    } else {
      dataAnggota[idx]["alamat_tinggal"] = list.alamat_domisili;
    }
    return list;
  });
  // dataDetail?.downloadPengurusProvinsi?.data?.sort((a, b) => a?.data_diri?.id_jabatan > b?.data_diri?.id_jabatan ? 1 : -1);
  let unik = [];
  dataAnggota?.sort(function (a, b) {
    if (a?.alamat_tinggal?.id_provinsi === b?.alamat_tinggal?.id_provinsi) {
      if (a?.alamat_tinggal?.id_kabkot === b?.alamat_tinggal?.id_kabkot) {
        if (
          a?.alamat_tinggal?.id_kecamatan === b?.alamat_tinggal?.id_kecamatan
        ) {
          if (
            a?.alamat_tinggal?.id_kelurahan === b?.alamat_tinggal?.id_kelurahan
          ) {
            return a?.data_pribadi?.name - b?.data_pribadi?.name;
          }
          return (
            a?.alamat_tinggal?.id_kelurahan - b?.alamat_tinggal?.id_kelurahan
          );
        }
        return (
          a?.alamat_tinggal?.id_kecamatan - b?.alamat_tinggal?.id_kecamatan
        );
      }
      return a?.alamat_tinggal?.id_kabkot - b?.alamat_tinggal?.id_kabkot;
    }
    return a?.alamat_tinggal?.id_provinsi > b?.alamat_tinggal?.id_provinsi
      ? 1
      : -1;
  });

  globalData?.dataProvince?.data?.sort(function (a, b) {
    return a?.kode_prov_bps > b?.kode_prov_bps ? 1 : -1;
  });

  dataAnggota?.map((list, idx, arr) => {
    const prevValue = arr[idx - 1];
    if (
      prevValue?.alamat_tinggal?.id_kabkot !== list?.alamat_tinggal?.id_kabkot
    ) {
      unik.push({
        id_provinsi: list?.alamat_tinggal?.id_provinsi,
        id_kabkot: list?.alamat_tinggal?.id_kabkot,
        nama_provinsi: list?.alamat_tinggal?.nama_provinsi,
        nama_kabkot: list?.alamat_tinggal?.nama_kab_kot,
      });
    }
    return list;
  });

  // console.log(dataDetail)
  // console.log(globalData)
  useEffect(async () => {
    // dispatch(getProvince());
    dispatch(getDownloadPengurusKabkot("", "", "", ""));
    dispatch(getKabKot(selectProvinsi));
    dispatch(getDownloadDaftarAnggota("", "", selectProvinsi, selectKabkot));
  }, [dispatch]);

  const handleSelectProv = async (event) => {
    setProvince(event.target.value);
    // setCities("0")
    if (event.target.value !== "0") {
      let a = await dispatch(getKabKot(event.target.value));
      if (a) {
        // let tempOp = [{kode_kab_kota_bps:0,nama_kab_kota_kemdagri:"Semua Kab/Kota"}]
        setCities(a?.payload[0]?.kode_kab_kota_bps);
        // let tempOp = []
        // a?.payload?.map((list,idx)=>{
        // 	tempOp[idx] = list
        // 	return list
        // })
        // setOptionKabkot(tempOp)
      }
    }
  };
  const handleSelectCity = async (event) => {
    setCities(event.target.value);
  };

  const filterDaerah = () => {
    dispatch(getDownloadDaftarAnggota("", "", selectProvinsi, selectKabkot));
    // if(selectKabkot !== "0"){
    //   dispatch(getDownloadDaftarAnggota("","",selectProvinsi,selectKabkot));
    // }
    // else {
    // 	dispatch(getDownloadDaftarAnggota("","",selectProvinsi,""));
    // }
  };

  const convertDate = (time) => {
    let date = new Date(time);
    let month = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];
    return `${(date.getDate() < 10 ? "0" : "") + date.getDate()} ${month[date.getMonth()]} ${date.getFullYear()}`;
  };

  const getAge = (dateString) => {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const exportToWord = async (element, filename) => {
    let css =
      "<style>@page download-paper{size: 11.69in 8.27in;mso-page-orientation: landscape;margin:0.75in 0.50in 0.75in 0.50in;} div.download-paper {page: download-paper;} div.break-page {mso-special-character:line-break;page-break-before:always;}</style>";
    var preHtml =
      "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title>" +
      css +
      "</head><body>";
    var postHtml = "</body></html>";
    var html = preHtml + document.getElementById(element).innerHTML + postHtml;

    var blob = new Blob(["\ufeff", html], {
      type: "application/msword",
    });

    // Specify link url
    var url =
      "data:application/vnd.ms-word;charset=utf-8," + encodeURIComponent(html);

    // Specify file name
    filename = filename ? filename + ".doc" : "document.doc";

    // Create download link element
    var downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // Create a link to the file
      downloadLink.href = url;

      // Setting the file name
      downloadLink.download = filename;

      //triggering the function
      downloadLink.click();
    }

    document.body.removeChild(downloadLink);
  };

  let alphabet = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "AA",
    "AB",
    "AC",
    "AD",
    "AE",
    "AF",
    "AG",
    "AH",
    "AI",
    "AJ",
    "AK",
    "AL",
    "AM",
    "AN",
    "AO",
    "AP",
    "AQ",
    "AR",
    "AS",
    "AT",
    "AU",
    "AV",
    "AW",
    "AX",
    "AY",
    "AZ",
  ];
  let temp = 0;
  let tempKel = 0;
  // let TEMP = 0;

  return (
    <>
      <div className="download-page">
        {/* Premium Header - Dark Blue Gradient */}
        <div
          id="premium-download-header"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 32px",
            background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
            position: "sticky",
            top: 0,
            zIndex: 100,
            gap: 24,
          }}
        >
          {/* Left - Title */}
          <div style={{ minWidth: 200 }}>
            <h2
              style={{
                fontSize: 18,
                fontWeight: 700,
                color: "#ffffff",
                margin: 0,
                letterSpacing: "0.5px",
                lineHeight: 1.2,
              }}
            >
              Daftar Nama & Alamat Anggota
            </h2>
            <p
              style={{
                fontSize: 12,
                color: "rgba(255, 255, 255, 0.7)",
                margin: "4px 0 0",
                fontWeight: 400,
              }}
            >
              Partai Buruh
            </p>
          </div>

          {/* Middle - Filters */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              flex: 1,
              justifyContent: "center",
            }}
          >
            <select
              value={selectProvinsi}
              onChange={(event) => handleSelectProv(event)}
              style={{
                padding: "8px 12px",
                borderRadius: 8,
                border: "1px solid rgba(255,255,255,0.2)",
                backgroundColor: "rgba(255,255,255,0.1)",
                color: "white",
                fontSize: 13,
                outline: "none",
                cursor: "pointer",
                maxWidth: 200,
              }}
            >
              {globalData?.dataProvince?.data?.map((list, idx) => {
                return (
                  <option
                    key={idx}
                    value={list.kode_prov_bps}
                    style={{ color: "black" }}
                  >
                    {list.nama_prov_kemdagri}
                  </option>
                );
              })}
            </select>
            <select
              value={selectKabkot}
              onChange={(event) => handleSelectCity(event)}
              style={{
                padding: "8px 12px",
                borderRadius: 8,
                border: "1px solid rgba(255,255,255,0.2)",
                backgroundColor: "rgba(255,255,255,0.1)",
                color: "white",
                fontSize: 13,
                outline: "none",
                cursor: "pointer",
                maxWidth: 200,
              }}
            >
              {globalData?.dataKabKot?.data?.map((list, idx) => {
                return (
                  <option
                    key={idx}
                    value={list.kode_kab_kota_bps}
                    style={{ color: "black" }}
                  >
                    {list.nama_kab_kota_kemdagri}
                  </option>
                );
              })}
            </select>
            <button
              onClick={filterDaerah}
              style={{
                padding: "8px 16px",
                borderRadius: 8,
                border: "none",
                backgroundColor: "#f36f21",
                color: "white",
                fontSize: 13,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Saring
            </button>
          </div>

          {/* Right - Action Buttons */}
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <button
              onClick={() => exportToWord("download-paper", "Daftar Anggota")}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                padding: "10px 20px",
                backgroundColor: "#4caf50",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
                transition: "all 0.2s ease",
                color: "#ffffff",
                fontSize: 14,
                fontWeight: 600,
                boxShadow: "0 2px 8px rgba(76, 175, 80, 0.3)",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#43a047";
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = "#4caf50";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <DownloadIcon style={{ fontSize: 20 }} />
              Download
            </button>

            <button
              onClick={() => param.setOpenDownload(false)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 44,
                height: 44,
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                borderRadius: 12,
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor =
                  "rgba(255, 255, 255, 0.2)";
                e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.4)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor =
                  "rgba(255, 255, 255, 0.1)";
                e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.2)";
              }}
            >
              <CloseIcon style={{ fontSize: 22, color: "#ffffff" }} />
            </button>
          </div>
        </div>
        <div id="download-paper">
          {unik?.map((list2, index) => {
            let arrData2 = [];
            arrData2 = dataAnggota?.filter(function (el) {
              return el?.alamat_tinggal?.id_kabkot === list2?.id_kabkot;
            });
            let getLeader = dataDetail?.downloadPengurusKabkot?.data?.filter(
              function (el) {
                return (
                  parseInt(el?.tingkat_exco?.id_kabkot) ===
                  parseInt(list2?.id_kabkot)
                );
              },
            );
            let ketua = "-";
            let sekre = "-";
            if (getLeader?.length) {
              let ketuaTemp = getLeader?.filter(function (el) {
                return el?.data_diri?.id_jabatan === 1;
              });
              let sekreTemp = getLeader?.filter(function (el) {
                return el?.data_diri?.id_jabatan === 3;
              });
              if (ketuaTemp?.length) {
                ketua = ketuaTemp[0]?.data_diri?.nama;
              }
              if (sekreTemp?.length) {
                sekre = sekreTemp[0]?.data_diri?.nama;
              }
            }
            // tempidx = 0;
            temp = 0;
            return (
              <div className="download-paper download-paper-landscape">
                <div style={{ textAlign: "center" }}>
                  DAFTAR NAMA DAN ALAMAT ANGGOTA PARTAI POLITIK <br />
                  DALAM WILAYAH KABUPATEN/KOTA <br />
                  PARTAI BURUH
                </div>
                <br />
                <br />
                <div
                  key={index}
                  className="download-table"
                  style={{ width: "100%" }}
                >
                  <br />
                  PROVINSI : {list2?.nama_provinsi}
                  <br />
                  KABUPATEN/KOTA : {list2?.nama_kabkot}
                  <table
                    frame="border"
                    cellspacing="0"
                    cellpadding="0"
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      border: "1px solid black",
                    }}
                  >
                    <thead>
                      <tr style={{ textAlign: "center" }}>
                        <td
                          style={{ padding: "4px", border: "1px solid black" }}
                        >
                          NO.
                        </td>
                        <td
                          style={{ padding: "4px", border: "1px solid black" }}
                        >
                          NAMA
                        </td>
                        <td
                          style={{ padding: "4px", border: "1px solid black" }}
                        >
                          UMUR
                        </td>
                        <td
                          style={{ padding: "4px", border: "1px solid black" }}
                        >
                          NO. KARTU TANDA ANGGOTA
                        </td>
                        <td
                          style={{ padding: "4px", border: "1px solid black" }}
                        >
                          NOMOR INDUK KEPENDUDUKAN
                        </td>
                        <td
                          style={{ padding: "4px", border: "1px solid black" }}
                        >
                          ALAMAT
                        </td>
                        <td
                          style={{ padding: "4px", border: "1px solid black" }}
                        >
                          KECAMATAN
                        </td>
                        <td
                          style={{ padding: "4px", border: "1px solid black" }}
                        >
                          KELURAHAN
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {arrData2?.map((list, idx, arr) => {
                        const prevValue = arr[idx - 1];
                        // let arrData = [];
                        // let flag = false;
                        if (
                          prevValue?.alamat_tinggal?.id_kelurahan !==
                          list?.alamat_tinggal?.id_kelurahan
                        ) {
                          tempKel++;
                        }
                        if (
                          prevValue?.alamat_tinggal?.id_kecamatan !==
                          list?.alamat_tinggal?.id_kecamatan
                        ) {
                          tempKel = 0;
                          // flag = true;
                          temp++;
                          // tempidx = idx;
                          // arrData = arr.filter(function (el) {
                          // 	return el?.alamat_tinggal?.id_kecamatan === list?.alamat_tinggal?.id_kecamatan
                          // });
                        }
                        return (
                          <>
                            <tr key={idx}>
                              <td
                                style={{
                                  padding: "4px",
                                  borderBottom: "1px solid black",
                                  borderRight: "1px solid black",
                                  textAlign: "center",
                                }}
                              >
                                {idx + 1}
                              </td>
                              <td
                                style={{
                                  padding: "4px",
                                  borderBottom: "1px solid black",
                                  borderRight: "1px solid black",
                                }}
                              >
                                {list?.data_pribadi?.name}
                              </td>
                              <td
                                style={{
                                  padding: "4px",
                                  borderBottom: "1px solid black",
                                  borderRight: "1px solid black",
                                  textAlign: "center",
                                }}
                              >
                                {getAge(list?.data_pribadi?.tgl_lahir)}
                              </td>
                              <td
                                style={{
                                  padding: "4px",
                                  borderBottom: "1px solid black",
                                  borderRight: "1px solid black",
                                  textAlign: "center",
                                }}
                              >
                                {list?.data_pribadi?.no_kta}
                              </td>
                              <td
                                style={{
                                  padding: "4px",
                                  borderBottom: "1px solid black",
                                  borderRight: "1px solid black",
                                  textAlign: "center",
                                }}
                              >
                                {list?.data_pribadi?.nik}
                              </td>
                              <td
                                style={{
                                  padding: "4px",
                                  borderBottom: "1px solid black",
                                  borderRight: "1px solid black",
                                }}
                              >
                                {list?.alamat_tinggal?.alamat}
                              </td>
                              <td
                                style={{
                                  padding: "4px",
                                  borderBottom: "1px solid black",
                                  borderRight: "1px solid black",
                                }}
                              >
                                {alphabet[temp - 1]}.{" "}
                                {list?.alamat_tinggal?.nama_kecamatan}
                              </td>
                              <td
                                style={{
                                  padding: "4px",
                                  borderBottom: "1px solid black",
                                  borderRight: "1px solid black",
                                }}
                              >
                                {tempKel + 1}.{" "}
                                {list?.alamat_tinggal?.nama_kelurahan}
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <br />
                <br />
                <div style={{ textAlign: "center" }}>
                  Jakarta, {convertDate(new Date())}
                </div>
                <br />
                <div style={{ textAlign: "center" }}>
                  PIMPINAN PARTAI POLITIK TINGKAT KABUPATEN/KOTA
                  <br />
                  PARTAI BURUH
                </div>
                <br />
                <br />
                <div style={{ textAlign: "center" }}>
                  <table style={{ width: "100%", textAlign: "center" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "50%", textAlign: "center" }}>
                          Ketua
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                          {ketua}
                        </td>
                        <td style={{ width: "50%", textAlign: "center" }}>
                          Sekretaris
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                          {sekre}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <pre>
                  <br clear="all" className="break-page" />
                </pre>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
